// File Name: Partners.jsx

import React from "react";

import Marquee from "react-fast-marquee";

export default function Partners() {

  const partners = [
    { name: "Bluebriss System" },
    { name: "Crescent IT Solutions" },
  ];

  return (
    <section

      className="
        relative

        py-16 sm:py-20 md:py-24

        overflow-hidden

        bg-gradient-to-b
        from-[#F8F4FB]
        via-white
        to-[#F5EEFA]

        border-y
        border-purple-100/60
      "

      data-testid="partners-section"
    >

      {/* ===================================================== */}
      {/* TOP GLOW */}
      {/* ===================================================== */}

      <div
        className="
          absolute

          top-[-120px]
          left-[-120px]

          w-[260px]
          h-[260px]

          sm:w-[350px]
          sm:h-[350px]

          md:w-[450px]
          md:h-[450px]

          bg-purple-400/10

          rounded-full

          blur-[90px]
          md:blur-[120px]
        "
      />

      {/* ===================================================== */}
      {/* RIGHT GLOW */}
      {/* ===================================================== */}

      <div
        className="
          absolute

          bottom-[-120px]
          right-[-120px]

          w-[260px]
          h-[260px]

          sm:w-[350px]
          sm:h-[350px]

          md:w-[450px]
          md:h-[450px]

          bg-fuchsia-400/10

          rounded-full

          blur-[90px]
          md:blur-[120px]
        "
      />

      {/* ===================================================== */}
      {/* GRID */}
      {/* ===================================================== */}

      <div
        className="
          absolute inset-0

          grid-bg

          opacity-[0.04]
        "
      />

      <div
        className="
          relative

          max-w-7xl
          mx-auto

          px-4 sm:px-6 md:px-8
        "
      >

        {/* ===================================================== */}
        {/* LABEL */}
        {/* ===================================================== */}

        <div
          className="
            text-center

            text-[11px]
            sm:text-sm

            uppercase

            tracking-[0.25em]
            sm:tracking-[0.35em]

            text-purple-600

            mb-8 sm:mb-10 md:mb-12

            font-semibold
          "
        >

          Trusted by leading companies

        </div>

        {/* ===================================================== */}
        {/* MARQUEE */}
        {/* ===================================================== */}

        <Marquee
          speed={35}
          gradient={false}
          pauseOnHover
        >

          {partners
            .concat(partners)
            .map((partner, index) => (

              <div
                key={index}

                className="
                  group

                  mx-3 sm:mx-5 md:mx-8
                  lg:mx-12

                  flex items-center

                  gap-3 sm:gap-4 md:gap-5

                  px-4 sm:px-5 md:px-7
                  py-4 sm:py-5

                  rounded-[24px]
                  md:rounded-3xl

                  bg-white/65
                  backdrop-blur-2xl

                  border
                  border-purple-100/60

                  shadow-[0_10px_35px_rgba(120,70,180,0.08)]

                  hover:shadow-[0_20px_50px_rgba(120,70,180,0.14)]

                  hover:-translate-y-1

                  transition-all
                  duration-500

                  min-w-[250px]
                  sm:min-w-[320px]
                "
              >

                {/* ===================================================== */}
                {/* ICON */}
                {/* ===================================================== */}

                <div
                  className="
                    relative

                    w-12
                    h-12

                    sm:w-14
                    sm:h-14

                    md:w-16
                    md:h-16

                    rounded-2xl

                    flex
                    items-center
                    justify-center

                    shrink-0

                    bg-gradient-to-br
                    from-[#6D3B8C]
                    via-[#9B4D96]
                    to-[#C67BCF]

                    shadow-lg
                    shadow-purple-500/20

                    overflow-hidden
                  "
                >

                  {/* INNER GLOW */}

                  <div
                    className="
                      absolute inset-0

                      bg-white/10

                      blur-xl
                    "
                  />

                  <span
                    className="
                      relative

                      text-white

                      font-bold

                      text-lg
                      sm:text-xl
                    "
                    style={{
                      fontFamily: "Sora",
                    }}
                  >

                    {partner.name.charAt(0)}

                  </span>

                </div>

                {/* ===================================================== */}
                {/* NAME */}
                {/* ===================================================== */}

                <div className="min-w-0">

                  <span
                    className="
                      block

                      text-slate-800

                      font-semibold

                      text-sm
                      sm:text-base
                      md:text-lg

                      truncate

                      group-hover:text-purple-700

                      transition-colors
                      duration-300
                    "
                    style={{
                      fontFamily: "Sora",
                    }}
                  >

                    {partner.name}

                  </span>

                  <span
                    className="
                      text-xs
                      sm:text-sm

                      text-slate-500

                      leading-relaxed
                    "
                  >

                    Enterprise Technology Partner

                  </span>

                </div>

              </div>

            ))}

        </Marquee>

      </div>

    </section>
  );
}